import { render, staticRenderFns } from "./ReportTurn.vue?vue&type=template&id=05238f87&"
import script from "./ReportTurn.vue?vue&type=script&lang=js&"
export * from "./ReportTurn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports